import { getFieldTypes, types } from "./types"
const getTypeOptions = () => getFieldTypes().map(val => ({ label: types[val].label, val }))
export const basicSettings = [
    {
        name: "_nodel",
        type: "bool",
        label: "Nu se poate șterge",
        widget: "toggle",
        require: "admin",
    },
    { name: "type", type: "select", label: "Tip", getValues: getTypeOptions, require: "admin" },
    { name: "id", type: "text", label: "CSS ID" },
    { name: "_class", type: "text", label: "Clasa CSS" },
]
export const fieldSettings = [
    ...basicSettings,
    {
        name: "_hidden",
        type: "bool",
        label: "Ascuns",
        widget: "toggle",
        require: "admin",
        _hidden: true,
    },
    {
        name: "_invisible",
        type: "bool",
        label: "Ascuns",
        widget: "toggle",
    },
    { name: "_label", type: "text", label: "Etichetă" },
    { name: "_visibility", type: "bool", label: "CSS: Marchează vizibilitatea" },
    {
        name: "_child_visibility",
        type: "bool",
        label: "CSS: Marchează vizibilitatea pentru descendenti",
    },
    { name: "_renderer", type: "text", label: "Renderer", require: "admin" },
    { name: "renderChildren", type: "bool", label: "Render recursive", require: "admin" },
    { name: "region", type: "text", label: "Regiune" },
    { name: "_inner", type: "bool", label: "Container interior" },
    { name: "_inner2", type: "bool", label: "Container interior dublu" },
    {
        name: "state",
        type: "select",
        label: "Stare",
        widget: "checkbox",
        multiple: true,
        values: [],
        _hidden: true,
    },
    { name: "_nowrap", type: "bool", label: "Fără container interior" },
]
//export const metaSettings = fieldSettings
export const entitySettings = basicSettings
export const nodeSettings = [
    /*{
        name: "pathauto",
        type: "bool",
        label: "Pathauto",
        widget: "toggle",
        set: (e, v) => {
            if (v) return { ...e, _c: { ...(e._c || {}), pathauto: true } }
            const _c = e._c || {}
            const { pathauto, ...rest } = _c
            return { ...e, _c: rest }
        },
    },*/
]
